import request from '@/util/request'

// Event-log actions resolve as {result, eventLog, resolution}.
const eventResult = (payload) => payload.result

export const fetchRefiningPartners = () => request.get('/refinery/refining-partners')

export const fetchUpstreamRefiningContracts = () => (
  request.get('/refinery/upstream-refining-contracts')
)

export const createContract = (draft) => (
  request.post('/refinery/upstream-refining-contracts', draft).then(eventResult)
)

export const updateContract = (existing, draft) => (
  request.patch(`/refinery/upstream-refining-contracts/${existing.id}`, draft).then(eventResult)
)

export const setContractActive = (existing, active) => (
  request.patch(`/refinery/upstream-refining-contracts/${existing.id}`, {active}).then(eventResult)
)
